
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/auth";

const CTASection = () => {
  const { user } = useAuth();
  
  // Don't render this section for authenticated users
  if (user) {
    return null;
  }
  
  return (
    <section className="bg-primary/5 py-16">
      <div className="container">
        <div className="flex flex-col items-center text-center max-w-2xl mx-auto space-y-4">
          <h2 className="text-3xl font-bold tracking-tight">Ready to share your reagents?</h2>
          <p className="text-muted-foreground">
            Join our growing community of researchers sharing reagents and advancing science together.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mt-6">
            <Button asChild size="lg">
              <Link to="/auth/register">Create an Account</Link>
            </Button>
            <Button variant="outline" asChild size="lg">
              <Link to="/reagents">Browse Reagents</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
